import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Ng2TelInputDirective } from './ng2-tel-input.directive';

@NgModule({
  declarations: [Ng2TelInputDirective],
  imports: [CommonModule, FormsModule],
  exports: [Ng2TelInputDirective]
})
export class Ng2TelInputModule {}
